module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ModalBase', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.visible),
      expression: "visible"
    }],
    attrs: {
      "with-content": true
    },
    on: {
      "close": _vm.cancel
    }
  }, [_c('h1', [_vm._v(_vm._s(_vm.currentTrad.title))]), _vm._v(" "), _c('section', [_c('div', [_c('label', [_vm._v(_vm._s(_vm.currentTrad.position) + " x :")]), _vm._v(" "), _c('NumberInput', {
    attrs: {
      "value": _vm.offsetX
    },
    on: {
      "change": _vm.changePositionX
    }
  }), _vm._v("\n            mm\n        ")], 1), _vm._v(" "), _c('div', [_c('label', [_vm._v(_vm._s(_vm.currentTrad.position) + " y :")]), _vm._v(" "), _c('NumberInput', {
    attrs: {
      "value": _vm.offsetY
    },
    on: {
      "change": _vm.changePositionY
    }
  }), _vm._v("\n            mm\n        ")], 1)]), _vm._v(" "), _c('footer', [_c('ClientColorButton', {
    on: {
      "click": _vm.validate
    }
  }, [_vm._v(_vm._s(_vm.$trad.common.ok))]), _vm._v(" "), _c('ClientColorButton', {
    on: {
      "click": _vm.cancel
    }
  }, [_vm._v(_vm._s(_vm.$trad.common.cancel))])], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1e8744e6","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/plano/edits/move_fixings.vue
// module id = 3064
// module chunks = 0